import { render, staticRenderFns } from "./listdalamprovinsi.vue?vue&type=template&id=6d5684e6&"
import script from "./listdalamprovinsi.vue?vue&type=script&lang=js&"
export * from "./listdalamprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports